import {
  BookOpen,
  Bell,
  Calendar,
  Code,
  Crown,
  Flame,
  Gamepad2,
  Globe,
  Hash,
  Headphones,
  Heart,
  Lock,
  Megaphone,
  MessageCircle,
  Mic,
  Music,
  Palette,
  Pin,
  Rocket,
  Shield,
  Sparkles,
  Star,
  Target,
  Trophy,
  Users,
  Volume2,
  Zap,
  type LucideIcon,
} from 'lucide-react';

/**
 * Shared icon palette for community/channel glyphs — used by the Theme Studio
 * pickers AND the live community rail, so a channel icon chosen in the studio
 * resolves to the same glyph everywhere. Stable string ids so a saved theme /
 * channel survives icon-set changes.
 */
export const COMMUNITY_ICONS: { id: string; icon: LucideIcon }[] = [
  { id: 'hash', icon: Hash },
  { id: 'message', icon: MessageCircle },
  { id: 'megaphone', icon: Megaphone },
  { id: 'volume', icon: Volume2 },
  { id: 'mic', icon: Mic },
  { id: 'trophy', icon: Trophy },
  { id: 'star', icon: Star },
  { id: 'sparkles', icon: Sparkles },
  { id: 'flame', icon: Flame },
  { id: 'zap', icon: Zap },
  { id: 'heart', icon: Heart },
  { id: 'game', icon: Gamepad2 },
  { id: 'music', icon: Music },
  { id: 'code', icon: Code },
  { id: 'palette', icon: Palette },
  { id: 'book', icon: BookOpen },
  { id: 'users', icon: Users },
  { id: 'shield', icon: Shield },
  { id: 'crown', icon: Crown },
  { id: 'rocket', icon: Rocket },
  { id: 'bell', icon: Bell },
  { id: 'calendar', icon: Calendar },
  { id: 'globe', icon: Globe },
  { id: 'headphones', icon: Headphones },
  { id: 'lock', icon: Lock },
  { id: 'pin', icon: Pin },
  { id: 'target', icon: Target },
];

const ICON_MAP: Record<string, LucideIcon> = Object.fromEntries(
  COMMUNITY_ICONS.map((i) => [i.id, i.icon]),
);

/** Resolve a stored icon id to a lucide component (falls back to a hash glyph). */
export function iconById(id: string | null | undefined): LucideIcon {
  return (id && ICON_MAP[id]) || Hash;
}
